import { styled } from "@mui/system";
import { Box, Typography, Paper } from "@mui/material";

export const Container = styled(Box)(({ theme }) => ({
    backgroundColor: "var(--grey-50-color)",
    padding: theme.spacing(2),
    borderRadius: 10,
}));

export const Title = styled(Typography)(({ theme }) => ({
    marginBottom: theme.spacing(1),
    fontSize: "1.1rem",
    letterSpacing: "0.05em",
    textTransform: "uppercase",
    fontStyle: "italic",
    color: "var(--primary-dark-color)",
}));

export const ScrollContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isFullWidth',
})(({ theme, isFullWidth = false }) => ({
    display: "flex",
    flexDirection: isFullWidth ? "column" : "row",
    overflow: isFullWidth ? "auto" : "auto",
    overflowX: isFullWidth ? "hidden" : "auto",
    overflowY: isFullWidth ? "auto" : "hidden",
    scrollBehavior: "smooth",
    gap: isFullWidth ? "16px" : "12px",
    padding: "8px 0",
    "&::-webkit-scrollbar": {
        height: isFullWidth ? "auto" : "6px",
        width: isFullWidth ? "6px" : "auto",
    },
    "&::-webkit-scrollbar-thumb": {
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        borderRadius: "10px",
    },
    "&::-webkit-scrollbar-track": {
        backgroundColor: "rgba(0, 0, 0, 0.1)",
        borderRadius: "10px",
    },
    [theme.breakpoints.up("md")]: {
        overflowX: isFullWidth ? "hidden" : "scroll",
        overflowY: isFullWidth ? "scroll" : "hidden",
    },
}));

export const DesafioItem = styled(Paper, {
  shouldForwardProp: (prop) => prop !== 'isWizard' && prop !== 'isFullWidth',
})(({ theme, isWizard, isFullWidth = false }) => ({
    width: isFullWidth ? "calc(100% - 2px)" : "270px",
    height: "120px",
    minHeight: "120px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "flex-end",
    padding: theme.spacing(2),
    borderRadius: 10,
    backgroundColor: "var(--grey-300-color)",
    border: `1px solid var(--grey-400-color)`,
    boxShadow: "none",
    overflow: "hidden",
    cursor: "pointer",
    boxSizing: "border-box",
    transition: "box-shadow 0.2s ease, transform 0.3s ease",
    "&:hover": {
        boxShadow: "2px 2px 4px rgba(0, 0, 0, 0.2)",
        transform: "scale(1.02)",
    },
    [theme.breakpoints.down("xs")]: {
        width: isFullWidth ? "calc(100% - 2px)" : isWizard ? "300px" : "180px",
        height: isFullWidth ? "auto" : "120px",
    },
}));

export const BoldText = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'isWizard',
})(({ theme, isWizard }) => ({
    fontWeight: "bold",
    fontSize: "1.3rem",
    color: isWizard ? "var(--white-color)" : "var(--primary-color)",
    marginBottom: theme.spacing(0.5),
    textAlign: isWizard ? "right" : "left",
    textTransform: isWizard ? "uppercase" : "none",
    fontStyle: isWizard ? "italic" : "normal",
    display: "-webkit-box",
    WebkitLineClamp: 2,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    lineHeight: "1.2",
    height: "calc(1.2em * 2)",
}));

export const Subtitle = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'isWizard',
})(({ theme, isWizard }) => ({
    fontSize: isWizard ? "1.3rem" : "1.1rem",
    color: isWizard ? "var(--engagement-color)" : "var(--grey-800-color)",
    marginBottom: theme.spacing(1),
    margin: isWizard ? "8px 0" : "10px 0px",
    textAlign: isWizard ? "right" : "left",
}));
